import Link from "next/link"

export default function AttorneyEndorsement({ attorney_name, category, excerpt, slug }) {
  return (
    <article className="p-7 bg-white flex flex-col h-full max-h-fit justify-center gap-4 border-0.5 border-grey-cool">
      <h2 className="text-center">
        <span className="block text-base font-primary font-medium text-primary mb-3 capitalize">{category?.name}</span>
        <span className="text-primary text-m3 lg:text-l1">{attorney_name}</span>
      </h2>
      <p className="text-center">{excerpt}</p>
      <Link
        href={slug}
        target="_self"
        className="underline decoration-secondary hover:decoration-tertiary decoration-2 underline-offset-8 relative mx-auto table"
      >
        Read Full Review
      </Link>
    </article>
  )
}
